import React from 'react';
import { BarChart3, CalendarRange, RefreshCw } from 'lucide-react';

export const DashboardLoader = () => (
  <div className="flex items-center justify-center py-10">
    <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-200 border-t-blue-600" />
  </div>
);

export const DashboardHeader = ({
  title,
  dateLabel,
  onOpenDatePicker,
  chartType,
  onChartTypeChange,
  onRefresh,
  refreshing,
}) => (
  <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
    <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">{title}</h1>

    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
      <button
        type="button"
        onClick={onOpenDatePicker}
        className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50"
      >
        <CalendarRange className="h-4 w-4 text-slate-500" />
        {dateLabel}
      </button>

      <div className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-sm">
        <BarChart3 className="h-4 w-4 text-slate-500" />
        <select
          value={chartType}
          onChange={(e) => onChartTypeChange(e.target.value)}
          className="bg-transparent text-sm font-medium text-slate-700 outline-none"
        >
          <option value="bar">Bar Chart</option>
          <option value="line">Line Chart</option>
        </select>
      </div>

      <button
        type="button"
        onClick={onRefresh}
        disabled={refreshing}
        className="inline-flex items-center justify-center gap-2 rounded-lg bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 disabled:cursor-not-allowed disabled:opacity-60"
      >
        <RefreshCw className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
        Refresh
      </button>
    </div>
  </div>
);

export const DashboardStatCard = ({ label, value, hint, tone = 'blue', children }) => {
  const tones = {
    blue: 'from-blue-50 to-white border-blue-100 text-blue-700',
    amber: 'from-amber-50 to-white border-amber-100 text-amber-700',
    green: 'from-emerald-50 to-white border-emerald-100 text-emerald-700',
    purple: 'from-violet-50 to-white border-violet-100 text-violet-700',
  };

  return (
    <div className={`rounded-2xl border bg-gradient-to-br p-4 shadow-sm ${tones[tone] || tones.blue}`}>
      <div className="text-sm font-medium text-slate-600">{label}</div>
      <div className="mt-1 text-2xl font-bold">{value}</div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
      {children}
    </div>
  );
};
